export enum EnumLgEnvio {
  No = 0,
  Si = 1
}
